/* Add to cart, and quantity adjustment, from a product card.

   Talks to Shopify's cart AJAX endpoints directly rather than going through
   Dawn's cart machinery: the card is not inside a product form, and the two
   would fight over rendering the same control.

   Every card for a variant is kept in step, because the same product can appear
   more than once on a page (a category group and a related row, say), and
   updating only the one that was clicked leaves the others lying. */
(function () {
  /* Shopify hands prices back in cents and the shop's own money format sits on
     the mini cart, so formatting stays consistent with what Liquid rendered
     rather than guessing a currency. */
  function money(cents) {
    var body = document.querySelector('[data-money-format]');
    var fmt = (body && body.dataset.moneyFormat) || '${{amount}}';
    var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, amount);
  }

  function esc(str) {
    var d = document.createElement('div');
    d.textContent = str == null ? '' : str;
    return d.innerHTML;
  }

  /* Re-render the panel from the cart itself. Patching the existing rows would
     mean tracking removals and merges by hand; the cart is small enough that
     replacing the body is simpler and cannot drift. */
  function renderMiniCart(cart) {
    var body = document.querySelector('[data-mini-cart-body]');
    var actions = document.querySelector('[data-mini-cart-actions]');
    if (!body) return;

    if (!cart.item_count) {
      body.innerHTML = '<p class="mini-cart__empty">Your cart is empty</p>';
      if (actions) actions.hidden = true;
      return;
    }
    if (actions) actions.hidden = false;

    var rows = cart.items.map(function (item) {
      var img = item.image
        ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') + '" alt="" loading="lazy" width="120" height="120">'
        : '';
      return '<li data-variant="' + item.variant_id + '">' +
        '<a href="' + item.url + '" class="mini-cart__link">' + img +
          '<span class="mini-cart__meta">' +
            '<span class="mini-cart__title">' + esc(item.product_title) + '</span>' +
            '<span class="mini-cart__line">' + money(item.original_price) + '</span>' +
          '</span>' +
        '</a>' +
        '<div class="mini-cart__controls">' +
          '<div class="mini-cart__qty">' +
            '<button type="button" data-mc-step="-1" aria-label="Decrease quantity">&minus;</button>' +
            '<span data-mc-count>' + item.quantity + '</span>' +
            '<button type="button" data-mc-step="1" aria-label="Increase quantity">+</button>' +
          '</div>' +
          '<button type="button" class="mini-cart__remove" data-mc-remove aria-label="Remove ' + esc(item.product_title) + '">' +
            '<svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">' +
            '<path d="M2.5 4h11M6 4V2.6h4V4M4.4 4l.55 9.1a1 1 0 0 0 1 .9h4.1a1 1 0 0 0 1-.9L11.6 4M6.6 6.6v5M9.4 6.6v5"/></svg>' +
          '</button>' +
        '</div>' +
      '</li>';
    }).join('');

    body.innerHTML =
      '<ul class="mini-cart__items">' + rows + '</ul>' +
      '<div class="mini-cart__total"><span>Estimated total</span>' +
      '<strong data-mini-cart-total>' + money(cart.total_price) + '</strong></div>';
  }

  function setQty(variantId, qty) {
    document.querySelectorAll('.card-atc[data-variant="' + variantId + '"]').forEach(function (el) {
      el.dataset.qty = qty;
      var count = el.querySelector('.card-atc__count');
      if (count) count.textContent = qty;
    });
  }

  function setBusy(el, busy) {
    el.classList.toggle('is-busy', !!busy);
    el.querySelectorAll('button').forEach(function (b) { b.disabled = !!busy; });
  }

  /* The header count is Dawn's element; keep using it so its own scripts and
     ours do not disagree about where the number lives. */
  function refreshBadge(count) {
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    var badge = bubble.querySelector('.cart-count');
    if (count > 0) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'cart-count';
        badge.setAttribute('aria-hidden', 'true');
        bubble.appendChild(badge);
      }
      badge.textContent = count;
    } else if (badge) {
      badge.remove();
    }
    document.dispatchEvent(new CustomEvent('bb:cart-updated', { detail: { count: count } }));
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || r.statusText); });
      return r.json();
    });
  }

  function afterChange(el) {
    return fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        refreshBadge(cart.item_count);
        renderMiniCart(cart);
        syncCards(cart);
        syncCartPage(cart);
        return cart;
      })
      .finally(function () {
        setBusy(el, false);
        el.classList.remove('is-busy');
      });
  }

  /* The cart page shows line totals and a cart total that the steppers change.
     Without this they keep the figures the page was rendered with, which is
     worse than not updating at all: the numbers look authoritative and are
     wrong. A line that reaches zero leaves, and emptying the cart reloads so
     the empty state renders rather than being reconstructed here. */
  function syncCartPage(cart) {
    var rows = document.querySelectorAll('[data-cart-line]');
    if (!rows.length) return;

    if (!cart.item_count) { window.location.reload(); return; }

    var byVariant = {};
    cart.items.forEach(function (i) { byVariant[i.variant_id] = i; });

    rows.forEach(function (row) {
      var item = byVariant[row.dataset.variant];
      if (!item) { row.remove(); return; }
      var lineTotal = row.querySelector('[data-line-total]');
      if (lineTotal) lineTotal.textContent = money(item.original_line_price);
      var fallback = row.querySelector('.cart-fallback-qty');
      if (fallback) fallback.value = item.quantity;
    });

    var total = document.querySelector('[data-cart-total]');
    if (total) total.textContent = money(cart.total_price);
  }

  /* Cards for items no longer in the cart have to fall back to Add to cart;
     only reading the items would leave a removed product showing a stepper. */
  function syncCards(cart) {
    var counts = {};
    cart.items.forEach(function (i) { counts[i.variant_id] = i.quantity; });
    document.querySelectorAll('.card-atc').forEach(function (el) {
      var q = counts[el.dataset.variant] || 0;
      el.dataset.qty = q;
      var c = el.querySelector('.card-atc__count');
      if (c) c.textContent = q;
    });
  }

  /* Mini cart: adjust or remove a line. */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-mc-step]');
    var remove = e.target.closest('[data-mc-remove]');
    if (!step && !remove) return;
    e.preventDefault();

    var row = e.target.closest('li[data-variant]');
    var panel = e.target.closest('.mini-cart');
    if (!row || !panel || panel.classList.contains('is-busy')) return;

    var id = row.dataset.variant;
    var current = parseInt(row.querySelector('[data-mc-count]').textContent, 10) || 0;
    var next = remove ? 0 : Math.max(0, current + parseInt(step.dataset.mcStep, 10));

    panel.classList.add('is-busy');
    post(window.Shopify.routes.root + 'cart/change.js', { id: String(id), quantity: next })
      .then(function () { return afterChange(panel); })
      .catch(function (err) { panel.classList.remove('is-busy'); console.error('[bb-cart]', err); });
  });

  /* Touch has no hover, so the icon toggles the panel there. */
  document.addEventListener('click', function (e) {
    var wrap = document.querySelector('[data-mini-cart]');
    if (!wrap) return;
    var onIcon = e.target.closest('#cart-icon-bubble');
    if (onIcon && window.matchMedia('(hover: none)').matches) {
      e.preventDefault();
      wrap.classList.toggle('is-open');
      onIcon.setAttribute('aria-expanded', wrap.classList.contains('is-open'));
      return;
    }
    if (!e.target.closest('[data-mini-cart]')) {
      wrap.classList.remove('is-open');
      var icon = document.getElementById('cart-icon-bubble');
      if (icon) icon.setAttribute('aria-expanded', 'false');
    }
  });

  document.addEventListener('click', function (e) {
    var add = e.target.closest('.card-atc__add');
    var step = e.target.closest('.card-atc__qty [data-step]');
    if (!add && !step) return;

    var el = e.target.closest('.card-atc');
    if (!el || el.classList.contains('is-busy')) return;
    e.preventDefault();

    var id = el.dataset.variant;
    var current = parseInt(el.dataset.qty, 10) || 0;
    setBusy(el, true);

    if (add) {
      post(window.Shopify.routes.root + 'cart/add.js', { items: [{ id: Number(id), quantity: 1 }] })
        .then(function () { setQty(id, current + 1); return afterChange(el); })
        .catch(function (err) { setBusy(el, false); console.error('[bb-cart]', err); });
      return;
    }

    var next = Math.max(0, current + parseInt(step.dataset.step, 10));
    /* change.js takes the variant id as `id` and sets an absolute quantity, so
       zero removes the line without needing its line item key. */
    post(window.Shopify.routes.root + 'cart/change.js', { id: String(id), quantity: next })
      .then(function () { setQty(id, next); return afterChange(el); })
      .catch(function (err) { setBusy(el, false); console.error('[bb-cart]', err); });
  });
})();
